import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { promo_urls_pattrens, admin_urls_pattrens, creator_urls_pattrens, creator_client_urls_pattrens } from "./urls";
import MainBody from "./MainBody";
import { connect } from "react-redux";
import Login from "./Pages/User Pannel/authentication/Login";
import Signup from "./Pages/User Pannel/authentication/Signup";
import { useEffect } from "react";
import { authCheckState, authLogout, authSuccess } from "./store/actions/actions";
import TermsofServices from "./Pages/User Pannel/Terms/TermsofServices";
import PromoTermsofServices from "./Pages/User Pannel/Terms/PromoTermsofServices.js";
import '@fontsource/poppins';
import AppearanceRelease from "./Pages/User Pannel/Terms/ApperanceRelease.js";
import PrivacyPolicy from "./Pages/User Pannel/Terms/PrivacyPolicy.js";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

let theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});
theme = responsiveFontSizes(theme);

/**
 * Whether a session looks present WITHOUT waiting for authCheckState()'s
 * async cookie read to land in redux. Same cookies that action inspects, so
 * this is the earliest honest answer to "is this a logged-out visitor, or a
 * logged-in one mid-refresh?".
 */
const hasSessionCookies = () =>
  Boolean(Cookies.get("access_token") && Cookies.get("refresh_token"));

const RenderComponents = ({ authenticated, authSuccess, authLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const _authSuccess = searchParams.get("authSuccess");
    if (_authSuccess && _authSuccess === "1") {
      const access = searchParams.get("access");
      const refresh = searchParams.get("refresh");

      if (access && refresh) {
        authLogout();
        authSuccess({ access: access, refresh: refresh });
        toast.success("Account created successfuly");
      }
    }
    // eslint-disable-next-line 
  }, [location.search]);

  useEffect(() => {
    const isAuthenticated = authenticated;
    const isLoginPage = location.pathname === "/" || location.pathname === "/login";
    const searchParams = new URLSearchParams(location.search);

    if (!isAuthenticated && !isLoginPage) {
      // `authenticated` is derived from state.user, which starts null on
      // EVERY hard refresh — authCheckState() only populates it after
      // asynchronously reading the cookies. So for the first render or two,
      // "not authenticated" really means "not checked yet", and bouncing to
      // the login page here throws a logged-in user off the page they just
      // refreshed. It's supposed to round-trip back via ?next=, but that
      // only happens if `authenticated` later flips — and authCheckState()
      // swallows a failed token refresh in a bare catch, in which case it
      // never flips and the user is stranded on /?next=...
      //
      // The token cookies are the same thing authCheckState() looks at, so
      // use them to tell "logged out" apart from "still checking": if
      // they're present, stay put and let the check resolve. If they're
      // genuinely absent, this really is a logged-out visitor — redirect.
      if (hasSessionCookies()) return;
      const fullPath = location.pathname + location.search;
      navigate(`/?next=${encodeURIComponent(fullPath)}`, { replace: true });
    } else {
      // Only navigate when there's an actual post-login "next" target to
      // consume. This effect re-runs on every `authenticated` change,
      // including the normal authCheckState() resolution on every page
      // load/refresh — falling back to `location.pathname` here (dropping
      // `location.search`) used to unconditionally strip query params on
      // every refresh (e.g. /mrss/push-admin-portal?tab=approvals losing
      // ?tab=approvals and landing back on the default tab).
      const next = searchParams.get("next");
      if (next) navigate(next, { replace: true });
    }
    // eslint-disable-next-line
  }, [authenticated]);
  return <></>
}
function App(props) {
  useEffect(() => {
    props.authCheckState();
    // eslint-disable-next-line
  });



  const urls = props.is_promouser ? promo_urls_pattrens : props.is_creator_client ? creator_client_urls_pattrens : (props.is_admin ? admin_urls_pattrens : creator_urls_pattrens);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <RenderComponents authenticated={props.authenticated} authSuccess={props.authSuccess} authLogout={props.authLogout} />
        {props.authenticated ? (
          <MainBody>
            <Routes>
              {urls.map((url, index) =>
                !props.is_admin && url.admin_only ? (
                  <Route key={url}></Route>
                ) : (
                  <Route key={url} exact path={url.url} element={url.element} />
                )
              )}
            </Routes>
          </MainBody>
        ) : (
          <Routes>
            <Route path={"/creator_signup"} element={<Signup />} />
            <Route path={"/partner_signup169"} exact element={<Signup />} />
            <Route path={"/terms/privacypolicy"} exact element={<PrivacyPolicy />} />
            <Route path={"/terms/appereance"} exact element={<AppearanceRelease />} />
            <Route path={"/terms"} exact element={<TermsofServices />} />
            <Route path={"/promo_terms"} exact element={<PromoTermsofServices />} />
            <Route path={"/"} element={<Login />} />
            {/* <Route path="*" element={<Navigate to="/" />} /> */}
          </Routes>
        )}
      </Router>
    </ThemeProvider>
  );
}
const mapStatesToProps = (state) => {
  return {
    authenticated: state.user !== null,
    is_admin: state.user?.is_staff,
    is_creator: state.user?.creator,
    is_promouser: state.user?.is_promouser || false,
    is_creator_client: state.user?.is_creator_client || false,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(authCheckState()),
    authSuccess: (data) => dispatch(authSuccess(data)),
    authLogout: () => dispatch(authLogout()),
  };
};
export default connect(mapStatesToProps, mapDispatchToProps)(App);
